import { SlotRepository } from '../Repositories/SlotRepository';
import { User } from '../../../User/Model/User';
import { isSlotOperationRestricted, getRestrictionMessage } from './Utils/TimeRestriction';

export class UploadSlotExcelUseCase {
  constructor(private repo: SlotRepository) {}

  execute(file: File, current: User): Promise<void> {
    /* ── 시간 제한 체크 ─────────────────────────── */
    if (isSlotOperationRestricted(current, '발주')) {
      throw new Error(getRestrictionMessage('생성', current));
    }

    return this.repo.uploadExcel(file);
  }
}
